import type { Movement } from "./types";
import { movementDisplayAmountCents } from "./movement-display";
import { isRecordedActivity, movementActivityDate } from "./bank-posting";

export type MovementSortOrder = "date-desc" | "date-asc" | "amount-desc" | "amount-asc";

export function sortMovements(movements: Movement[], order: MovementSortOrder = "date-desc"): Movement[] {
  return [...movements].sort((a, b) => {
    const date = movementActivityDate(a).localeCompare(movementActivityDate(b));
    const recentFirst = -date || b.createdAt.localeCompare(a.createdAt) || a.id.localeCompare(b.id);
    if (order === "date-asc") return date || a.createdAt.localeCompare(b.createdAt) || a.id.localeCompare(b.id);
    if (order === "amount-asc") return movementDisplayAmountCents(a) - movementDisplayAmountCents(b) || recentFirst;
    if (order === "amount-desc") return movementDisplayAmountCents(b) - movementDisplayAmountCents(a) || recentFirst;
    return recentFirst;
  });
}

/** El resumen de Inicio nunca adelanta una parcialidad con fecha futura. */
export function latestRecordedExpense(movements: Movement[], today: string): Movement | undefined {
  return sortMovements(
    movements.filter((movement) => isRecordedActivity(movement, today)),
  )[0];
}
